import { toggleSingleSceneObject } from "../../togglers";
import { OFFSET_GAZZLIFT, OFFSET_GLIDERS } from "./pos_map";

export const changePodlokotniki = (isChecked) => {
    const stulName = servObj.tempName;
    const name = `stul__${stulName}__podlokotniki`;

    let posY = 10;

    const isVisokiyGazzlift = servObj.activeGazlifts.some((gazlift) => gazlift.userData.type === "visokiy");
    const isOporaGlaydery = servObj.activeOpora.some((opora) => opora.userData.type === "glaydery");

    if (isVisokiyGazzlift) {
        posY += OFFSET_GAZZLIFT.Y;
    }
    if (isOporaGlaydery) {
        posY -= OFFSET_GLIDERS.Y;
    }

    toggleSingleSceneObject({
        allObjects: servObj.allPodlokotniki,
        activeArray: servObj.activePodlokotniki,
        name,
        isChecked,
        position: { y: posY },
        userData: { name },
    });
};
